import { render } from "./InputDecimal.vue?vue&type=template&id=a4c49c60"
import script from "./InputDecimal.vue?vue&type=script&lang=js"
export * from "./InputDecimal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__